"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrderStatus = void 0;
var OrderStatus;

(function (OrderStatus) {
  OrderStatus["UNKNOWN"] = "UNKNOWN";
  OrderStatus["DRAFT"] = "DRAFT";
  OrderStatus["NEW"] = "NEW";
  OrderStatus["DRIVER_LOADING"] = "DRIVER_LOADING";
  OrderStatus["DELIVERING"] = "DELIVERING";
  OrderStatus["ARRIVED"] = "ARRIVED";
  OrderStatus["DONE"] = "DONE";
  OrderStatus["CANCELED"] = "CANCELED";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));